"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _TableHead = _interopRequireDefault(require("@material-ui/core/TableHead"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _TableSortLabel = _interopRequireDefault(require("@material-ui/core/TableSortLabel"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const styles = theme => ({
  tableCell: {
    fontSize: '1em',
    color: theme.palette.primary.main
  },
  tableSortLabel: {
    color: 'inherit'
  }
});
class EnhancedTableHead extends _react.Component {
  createSortHandler = (e, column) => {
    this.props.onRequestSort(e, column);
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let cells = props.columns.map(function (column, i) {
      let sort_label;
      if (column.sortable !== false) {
        let styles = {};
        if (column.center === true) {
          styles['paddingLeft'] = '16px';
        }
        sort_label = /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
          title: "Trier",
          placement: column.numeric ? 'bottom-end' : 'bottom-start',
          enterDelay: 320
        }, /*#__PURE__*/_react.default.createElement(_TableSortLabel.default, {
          style: styles,
          className: props.classes.tableSortLabel,
          active: props.order_by === column.id,
          direction: props.order,
          onClick: function (e) {
            component.createSortHandler(e, column);
          }
        }, column.label));
      } else {
        sort_label = column.label;
      }
      let styles;
      if (column.center === true) {
        styles = {
          textAlign: 'center'
        };
      }
      let output = /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: (props.classes.tableCell || '') + ' table-cell',
        align: column.align || column.numeric ? 'right' : 'left',
        key: i,
        sortDirection: props.order_by === column.id ? props.order : false,
        style: styles
      }, sort_label);
      return output;
    });
    let selection;
    if (props.onSelectAllClick) {
      selection = /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        padding: "checkbox",
        style: {
          textAlign: 'left'
        }
      }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        onChange: props.onSelectAllClick,
        indeterminate: props.selected_count > 0 && props.selected_count < props.row_count,
        checked: props.selected_count > 0 && props.selected_count === props.row_count
      }));
    }
    let output = /*#__PURE__*/_react.default.createElement(_TableHead.default, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, null, selection, cells));
    return output;
  }
}
EnhancedTableHead.propTypes = {
  onRequestSort: _propTypes.default.func,
  onSelectAllClick: _propTypes.default.func,
  selected_count: _propTypes.default.number,
  order: _propTypes.default.string.isRequired,
  order_by: _propTypes.default.string.isRequired,
  row_count: _propTypes.default.number.isRequired,
  classes: _propTypes.default.object.isRequired
};
var _default = exports.default = (0, _styles.withStyles)(styles)(EnhancedTableHead);
